import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgIdleModule } from "@ng-idle/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { LaddaModule } from "angular2-ladda";
import { NgCircleProgressModule } from "ng-circle-progress";
import { MomentModule } from "ngx-moment";
import { NgbPaginationModule, NgbDatepickerModule, NgbTimepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { Ng2CompleterModule } from "ng2-completer";


@NgModule({
  imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgbModule,
        NgIdleModule.forRoot(),
        MomentModule,
        NgCircleProgressModule.forRoot(),
        NgbPaginationModule,
        NgbDatepickerModule,
        NgbTimepickerModule,
        LaddaModule.forRoot({
            style: "expand-right"
        }),
    Ng2CompleterModule,
    
    ],
  exports: [

        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgbModule,
        NgIdleModule,
        NgSelectModule,
        MomentModule,
        NgCircleProgressModule,
        NgbPaginationModule,
        NgbDatepickerModule,
        NgbTimepickerModule,
        LaddaModule,
    Ng2CompleterModule,

  ]
})
export class SharedCommonModule {
}
